import shareMutations from 'vuex-shared-mutations'

const mutationsToShare = [
  'cart/SET_CART_STATE',
  'cart/SET_FORM_KEY',
  'cart/ADD_MESSAGE',
  'cart/CLEAN_MESSAGES',
  'store/*'
]

export default ({ store }) => {
  window.onNuxtReady((nuxt) => {
    shareMutations({
      predicate: (mutation, state) => {
        const module = mutation.type.split('/')[0]
        return mutationsToShare.includes(mutation.type) || mutationsToShare.includes(`${module}/*`)
      }
    })(store)
  })
}